import { render } from "./SignerRoomMobile.vue?vue&type=template&id=2b180e35&scoped=true"
import script from "./SignerRoomMobile.vue?vue&type=script&lang=js"
export * from "./SignerRoomMobile.vue?vue&type=script&lang=js"

import "./SignerRoomMobile.vue?vue&type=style&index=0&id=2b180e35&lang=css"
import "./SignerRoomMobile.vue?vue&type=style&index=1&id=2b180e35&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b180e35"]])

export default __exports__